import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './sass/style.scss';
import reportWebVitals from './reportWebVitals';
import { BaseRoutes } from './containers/routes';

ReactDOM.render(
  <React.StrictMode>
    <BaseRoutes />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
